import React from "react";

import { PlaceOrderForm } from "./PlaceOrderForm";
import { usePlaceOrder } from "../../hooks/usePlaceOrder";

export function PlaceOrder({
  onPlaceOrder,
  onSubmit,
  checkoutData,
  formValues,
}) {
  const {
    placeOrder,
    loading,
    paymentBlocked,
    onPaymentSuccess,
    onPaymentError,
    onValidationChange,
    onSubmitAvailable,
  } = usePlaceOrder({
    onPlaceOrder,
    onSubmit,
    checkoutSummary: {
      ...checkoutData,
      // LMS always collects payment; default true if prepareCheckout omits the flag
      ccRequired: checkoutData?.ccRequired ?? true,
    },
    formValues,
  });

  return (
    <div className="checkout-place-order">
      <PlaceOrderForm
        submit={placeOrder}
        checkoutData={checkoutData}
        loading={loading}
        paymentBlocked={paymentBlocked}
        onPaymentSuccess={onPaymentSuccess}
        onPaymentError={onPaymentError}
        onValidationChange={onValidationChange}
        onSubmitAvailable={onSubmitAvailable}
      />
    </div>
  );
}
